module.exports = __webpack_public_path__ + "img/herder.4ba6c300.png";